import { Link } from "react-router";
import { motion } from "framer-motion";
import { useScrollDirection } from "@/hooks/useScrollDirection";
import {
  useIsMenuOpen,
  useIsDarkSlide,
  useIsInHeroSection,
} from "@/stores/uiStore";
import MenuButton from "./MenuButton";
import NavigationOverlay from "./NavigationOverlay";

export default function Header() {
  const isMenuOpen = useIsMenuOpen();
  const isDarkSlide = useIsDarkSlide();
  const isInHeroSection = useIsInHeroSection();
  const { scrollDirection, scrollY, isSticky } = useScrollDirection(100);

  const isHidden =
    isSticky && scrollDirection === "down" && scrollY > 200 && !isMenuOpen;

  return (
    <>
      <motion.header
        animate={{ y: isHidden ? "-100%" : 0 }}
        transition={{ duration: 0.3, ease: [0.33, 1, 0.68, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 md:px-12 md:py-8 lg:px-12 transition-[background-color,backdrop-filter] duration-300 ${
          isSticky ? "bg-zinc-950/95 backdrop-blur-[10px]" : ""
        }`}
      >
        <div className="flex items-center justify-between">
          <Link to="/" viewTransition className="z-50">
            <div className="flex items-baseline select-none font-display">
              <span className="font-bold text-4xl md:text-5xl tracking-tight text-[#eb6165] transition-colors duration-300">
                A
              </span>
              <span
                className={`font-bold text-3xl md:text-4xl tracking-tight transition-colors duration-300 ${
                  !isInHeroSection || !isDarkSlide
                    ? "text-white"
                    : "text-[#18181b]"
                }`}
              >
                fi
              </span>
            </div>
          </Link>

          <MenuButton />
        </div>
      </motion.header>
      <NavigationOverlay />
    </>
  );
}
